import React from "react";
import { Container } from "react-bootstrap";

const First = () => {
  return (
    <>
      <section className="first-webDevelopment-section">
        <Container>
          <div className="page-title text-center">
            <h1>Hire Dedicated Developers</h1>
            <div className="sub-info">
              <p>
                The code you need is here. Designed to be a one-stop shop for
                developers, Codeffi offers customized development services with
                a team of handpicked and dedicated engineers.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
